import { Div } from '../../../base/components/native/div'
import { CENTER, HIDE } from '../../../base/helpers/style'

export const Designs = () => {

    const base = Div('')
    base.cssClass({
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
        width: '670px',
       '@media (max-width: 670px)': {
            flexDirection: 'column',
        }
        
    })

    return base
}